
import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"
@Component({})
export default class SureViewIcon extends Vue {
	@Prop({ type: String, default: "md" })
	size!: string;

	get width () : number {
		switch (this.size) {
			case "lg": return 80
			case "sm": return 20
		}
		return 40
	}
}
